import { SpaceScale, SpaceScaleObject } from '../types/scale';
import { getClassName } from './getClassName';

/**
 * Gets a className from the classNames object given a className prefix and space.
 * This function creates type safety across the object, prefix, and space.
 *
 * @returns A string representing a className.
 */
export function getSpaceScaleClassName<P extends string>(
  classNames: SpaceScaleObject<P>,
  classNamePrefix: P,
  space: SpaceScale | undefined,
): string | undefined {
  if (space === undefined) {
    return getClassName(classNames, undefined);
  }

  const className: keyof SpaceScaleObject<P> = `${classNamePrefix}${space}` as const;
  return getClassName(classNames, className);
}
